import { createFileRoute } from "@tanstack/react-router";
import { SeriesBtsPage } from "@/modules/SeriesDetails";

export const Route = createFileRoute(
  "/_default/series/$series/behind-the-scenes",
)({
  component: SeriesBtsPage,
});
